import { useQuery } from "@tanstack/react-query";
import Sentry from "@similarweb/sentry-logger";
import { autocompleteStates } from "app/components/compare/WebsiteQueryBarTypes";
import { getRecentsAnalysis } from "app/services/solutions2Services/HomepageDataFetchers/NewModulesHomepageDataFetcher";

export const useRecentAnalysis = () => {
    return useQuery({
        queryKey: ["recentAnalysis", "website"],
        queryFn: async () => {
            try {
                const recentItems = await getRecentsAnalysis("website", true);
                if (recentItems.length === 0) {
                    return [autocompleteStates.NO_DATA_RECENTS];
                }
                return recentItems;
            } catch (e) {
                Sentry.error("Error fetching recents - LLM Homepage", e as Error);
                return [autocompleteStates.ERROR];
            }
        },
    });
};
